module.exports = __webpack_public_path__ + "static/img/kj-ic03.496cf2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/kj-ic03.png
// module id = 9Fv/
// module chunks = 19